export const HSL_MIN_VISIBLE_LIGHTNESS = 16;
export const HSL_MAX_VISIBLE_LIGHTNESS = 85;
export const HSL_DESATURATION_THRESHOLD = 17;
//# sourceMappingURL=constants.js.map